
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.167 7a5.833 5.833 0 1011.666 0A5.833 5.833 0 001.167 7zm10.606 0a4.773 4.773 0 11-9.546 0 4.773 4.773 0 019.546 0z","fill":"#585858"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.125 7.719L9.212 4.63l.825.825L6.125 9.37 3.962 7.206l.825-.825L6.125 7.72z","fill":"#585858"}})])
          )
        }
      }
    